import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { FiPlus, FiEdit2, FiTrash2, FiDownload, FiEye } from 'react-icons/fi';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

const SIGNATURE_IMG = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCABAAJYDASIAAhEBAxEB/8QAHAABAAIDAQEBAAAAAAAAAAAAAAQGAgUHAwEI/8QAOBAAAQMDAgQDBgQEBwAAAAAAAQIDBAAFEQYhEjFBURNhcQcUIjKBkRUWQmIXUqGxIyYzcpKiwf/EABgBAQEBAQEAAAAAAAAAAAAAAAABAgME/8QAHhEBAQEBAAMAAwEAAAAAAAAAAAECEQMSISIxQTL/2gAMAwEAAhEDEQA/AP2WRWJFZUNBhShoBmgdayHpXk88ywguPOpbQBklRwK1zmprA2oBV2ijP76Db0qDDvFqmHEW4xnT2S4M/ap2aBSlKBSlKBSlKBSlKBSlKBSlKBSlKDEjfaq9qS/SYclm12eGJ9zfPyFfChlHVxw74H9TWx1Lc02mzvTNlOABDKOrjitkpHmTiomjbMu0W5Tk1zx7lLWXpjx5qWf0j9o5AVYPKNpaPIIkX11dzlK3UHCfCR5JRyA9cmt01ChspCGorDaQNglsCo9/uTlrtypbNsmXJSVAeDECSvfrhRAxXPdZ+0bVdpaZVC0DJQHQshc2Y2gAJSVE4SVHkKfdHFi1nH04xkuaeVc7iocSWYbQDx8yoYwPMmqnbNWazsD+LhpG4osy1hDKpUpCnGyeQUoZ27Z71D0d/GqYlM12BpWEmaoPOyHpDrjgSRkJ4EpHIdM102PbLnJtMmHfp0aap9HCPBjeElH3USd8Vr5B66bv0S9suFpt2PIYVwSIzww40rsR/YjnW2Fc7iSFxtSWK9IHC3NC7ZPHdxGfDX9wR9RXQ08qzYPtKV8UTg4wT0qD7Sq9pufqZ26TYV9tLDDTRzHlMOZQ8knYYO4IHOrDQKVq9WznLZpi5XBlQS5HjLWgnkFAHB+9amyyL1apUSLeJqLjFmJAZlcIStLmM8KgNiD0NOC1UoKUClKUClKUFU1U6iVrHTdmWkqT4jk5Qxt/hJwn/soVa+lUz2gXFjT96s+o5jbyoccPMvFlHGocSQRsOfy1Ctftc0pc4wkw03Zxg/K4Le6Uq9CARWvW2HHQK577bWFv2y2ttf6jz7kcY/eysf3xUhr2nWR2SlhiBenSo4yIDgA+4rSz9ZOak1VEtlv0hfH27W97zIccbQ2AopIQASrzJ71cyy9anyug6Wlonabt0ps/C5GQT5HAyPocil8vMG1W+RJkPJHhJ+UHKio8kgdz0FUHxtaWKTJdVERA0zJcU6PBb8eVAUrdRIzgoJydgSnPaq87O0xYNfp1Ou6TNRMOWtPC42DJ4X/EwnZPwoUQSBnHI0mepVh1A0uD7N44kOhu4tSmJy0FXxo4ngf/AHFdQSQUgg9K/Pmrvzje9aQ1QrYh+XcGmnJdscc4PdYzbnEgqXyClHmMeldQtNu1xbI4Uu4wrqpaQpTUjLZaUeaUrSDlI6ZGdqus8/qLpWLquFBV2qtpf1ud/wAOsiR/KZThP34ajXmTrYRClm2WgrOySJCiAcbZBA2zXLfyLItUVa3GQteMnfasyRnnXIIkrXBcTG1Dpea66lI4nW5qzGUf2BpOQP8AdvUjT1u1pH1RIvMCGgRnmvBTDfccQw1vuvK/jUr0AFazn5+zjpGo4TVzsM63OqCUSY62ie3EkjNUrRF2VqnTsFCh8dpw1LVnIU+3tgHttnPnW/FgulyH+YLqHGjzjREFts+RJySK0kyF+Rr65cIbKRp64rSJjSEgCI5jhDgx+k7Z7Gmp+N5frUkXqFITKYDqQUk8wehqQK19pwC7wlJSTkFJ2NbCuXj1dZ7WdTlKUpXRClY8aO9AtJHOnKntEK/WyNeLY7AlIKm3BsRzSobhQ8wd65pF0nYvxlUJ+TN03eVqPC7BkFhuXj9QT8pVyJGK61UC+We3XqEYdyjIfazxJJ2UhQ5KSobpI7itTVjXWkj6TlmIYk/U10mtHG+Utrx2KkjJrfWq2wrZFEaDHQy2Nzjmo9yeZPmar/uGqbMkpttxYukUEcDU4lLqR24wPi9SAfWg1LfxILLmj5YwPnRKaKT6binLU6tmB2rT3A2XTlul3H3OPGQo8boZZAU8vpsBlSjyFQ03i+vOBLWnnGif1SJCAkf8STUi32Z92am43mZ72+k5ZaSOFln0HU+Z/pU5z9p1F0La5TDUu83RtKLlc3PFcT1abGzbf0HPzJqzUpS3qlRbogriKKQSpPxADrUqsVEciRWN59s2EvL1EtM1uXGBSTxJ2UCMGptaW4wnGnDIgL4Fk/EkdfOpNtnKdIaeTwuAbnNefx+Wy+mo3ZLOxsai3RMZcJ1qW2h1haSlaFDIUD0IrC4TPATwtjiWeXYVEajSZi0uSThGeXcenSteTyX/ADmfTOf7WjtirjpZxba471wsajll5v4now/lUnmpI6KH1qyW69Wq48IhT47ylckJWOL6jmKmjgSkJ2GBivJtmI06t1thpDi/mUlABV6nrXbx5uc8Y1qdSKVjxp70rXKnY//Z";

const toBase64 = (src) =>
  new Promise((resolve) => {
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const c = document.createElement('canvas');
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      c.getContext('2d').drawImage(img, 0, 0);
      resolve(c.toDataURL('image/png'));
    };
    img.onerror = () => resolve(src);
    img.src = src + '?t=' + Date.now();
  });

const empty = {
  toName:'', toTitle:'', toCompany:'', toAddress:'',
  subject:'', body:'', date: new Date().toISOString().split('T')[0],
  signedBy:'Joshua Owiredu', signedByTitle:'General Manager', refNumber:'',
};

const LetterheadPreview = ({ data, logoSrc }) => (
  <div id="letterhead-render" style={{
    width:595, height:842, background:'white',
    fontFamily:'Arial, Helvetica, sans-serif',
    position:'relative', boxSizing:'border-box', overflow:'hidden',
  }}>

    {/* ── TOP BAR: navy base + orange diagonal wedge ── */}
    <div style={{ position:'absolute', top:0, left:0, right:0, height:52, zIndex:2 }}>
      {/* Navy full-width base */}
      <div style={{ position:'absolute', inset:0, background:'#1B2A4A' }} />
      {/* Orange wedge: fills left ~60%, diagonal cut on right going bottom-left to top-right */}
      <svg style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%' }} viewBox="0 0 595 52" preserveAspectRatio="none">
        {/* Orange shape - left portion with diagonal right edge */}
        <polygon points="0,0 410,0 310,52 0,52" fill="#F5821F" />
      </svg>
    </div>

    {/* ── HEADER CONTENT ── */}
    <div style={{
      position:'absolute', top:60, left:0, right:0,
      display:'flex', justifyContent:'space-between', alignItems:'flex-start',
      padding:'0 28px', zIndex:3,
    }}>
      {/* Logo left */}
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <img src={logoSrc || '/logo.png'} alt="SQS Logo"
          style={{ width:48, height:48, objectFit:'contain' }} />
        <div>
          <div style={{ fontWeight:900, fontSize:17, color:'#F5821F', letterSpacing:'0.03em', lineHeight:1.1 }}>SMART</div>
          <div style={{ fontWeight:700, fontSize:9.5, color:'#1B2A4A', letterSpacing:'0.12em', lineHeight:1.2 }}>QUALITY SYSTEMS</div>
        </div>
      </div>

      {/* Contact info right */}
      <div style={{ textAlign:'right', fontSize:9, color:'#333', lineHeight:2.1 }}>
        <div><span style={{ fontWeight:700, color:'#1B2A4A' }}>Phone: </span>+233 246021515</div>
        <div><span style={{ fontWeight:700, color:'#1B2A4A' }}>Email: </span><span style={{ color:'#F5821F' }}>smartqualitygh@gmail.com</span></div>
        <div><span style={{ fontWeight:700, color:'#1B2A4A' }}>Address: </span><span style={{ color:'#F5821F' }}>Vanguard Assurance</span></div>
        <div style={{ color:'#F5821F' }}>Building, 1st Floor, Accra</div>
      </div>
    </div>

    {/* ── NAVY DIVIDER ── */}
    <div style={{
      position:'absolute', top:146, left:0, right:0,
      height:2.5, background:'#1B2A4A', zIndex:3,
    }} />

    {/* ── BODY ── */}
    <div style={{
      position:'absolute', top:162, left:28, right:28, bottom:88,
      zIndex:3, overflow:'hidden',
    }}>
      {/* Date + Ref */}
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:14, fontSize:10, color:'#333' }}>
        <div>{data.date && new Date(data.date).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'})}</div>
        {data.refNumber && <div><span style={{ fontWeight:700 }}>Ref: </span>{data.refNumber}</div>}
      </div>

      {/* TO */}
      <div style={{ marginBottom:16 }}>
        <div style={{ fontWeight:700, fontSize:11, color:'#2c5a92', marginBottom:4 }}>TO</div>
        {data.toName && <div style={{ fontSize:10, color:'#222', fontWeight:600 }}>{data.toName}</div>}
        {data.toTitle && <div style={{ fontSize:10, color:'#444' }}>{data.toTitle}</div>}
        {data.toCompany && <div style={{ fontSize:10, color:'#444' }}>{data.toCompany}</div>}
        {data.toAddress && <div style={{ fontSize:10, color:'#444', whiteSpace:'pre-line' }}>{data.toAddress}</div>}
      </div>

      {/* Subject */}
      {data.subject && (
        <div style={{ marginBottom:14, fontSize:10, fontWeight:700, color:'#1B2A4A', textDecoration:'underline', textTransform:'uppercase' }}>
          RE: {data.subject}
        </div>
      )}

      {/* Body */}
      <div style={{ fontSize:10, color:'#222', lineHeight:1.9, whiteSpace:'pre-wrap', marginBottom:20 }}>
        {data.body || ''}
      </div>

      <div style={{ fontSize:10, color:'#222', marginBottom:10 }}>Yours faithfully,</div>

      {/* Signature — right aligned */}
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        <div style={{ textAlign:'center', minWidth:175 }}>
          <img src={SIGNATURE_IMG} alt="Signature"
            style={{ height:40, width:'auto', maxWidth:155, objectFit:'contain', display:'block', margin:'0 auto 2px' }} />
          <div style={{ borderTop:'1.5px solid #1B2A4A', width:'100%', marginBottom:4 }} />
          <div style={{ fontWeight:700, fontSize:10, color:'#F5821F', letterSpacing:'0.03em' }}>
            {data.signedBy || 'Joshua Owiredu'}
          </div>
          <div style={{ fontSize:9, color:'#555', fontStyle:'italic' }}>
            {data.signedByTitle || 'General Manager'}
          </div>
        </div>
      </div>
    </div>

    {/* ── FOOTER CONTACT STRIP ── */}
    <div style={{
      position:'absolute', bottom:30, left:0, right:0,
      borderTop:'1px solid #ddd',
      padding:'5px 24px',
      display:'flex', justifyContent:'space-between', alignItems:'center',
      fontSize:8, color:'#333', background:'white', zIndex:3,
    }}>
      {/* Address with pin icon */}
      <div style={{ display:'flex', alignItems:'center', gap:5 }}>
        <svg width="11" height="13" viewBox="0 0 24 24" fill="#1B2A4A">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
        Vanguard Assurance Building 1st Floor, Accra
      </div>

      {/* Phone */}
      <div style={{ display:'flex', alignItems:'center', gap:5 }}>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="#1B2A4A">
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
        0246021515
      </div>

      {/* Email */}
      <div style={{ display:'flex', alignItems:'center', gap:5 }}>
        <svg width="12" height="10" viewBox="0 0 24 24" fill="#1B2A4A">
          <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
        smartqualitygh@gmail.com
      </div>
    </div>

    {/* ── BOTTOM BAR: navy base + orange diagonal wedge (mirrored) ── */}
    <div style={{ position:'absolute', bottom:0, left:0, right:0, height:30, zIndex:2 }}>
      {/* Navy full-width base */}
      <div style={{ position:'absolute', inset:0, background:'#1B2A4A' }} />
      {/* Orange wedge: fills right ~60%, diagonal cut on left — mirrors the top */}
      <svg style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%' }} viewBox="0 0 595 30" preserveAspectRatio="none">
        <polygon points="285,0 595,0 595,30 185,30" fill="#F5821F" />
      </svg>
    </div>

  </div>
);

export default function AdminLetterhead() {
  const [letters, setLetters] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [submitting, setSubmitting] = useState(false);
  const [generating, setGenerating] = useState(false);

  useEffect(() => { loadLetters(); }, []);

  const loadLetters = async () => {
    try { const r = await api.get('/letterheads'); setLetters(r.data); } catch {}
  };

  const openForm = (item=null) => {
    setEditing(item); setShowPreview(false);
    setForm(item ? {
      toName:item.to_name||'', toTitle:item.to_title||'',
      toCompany:item.to_company||'', toAddress:item.to_address||'',
      subject:item.subject||'', body:item.body||'',
      date:item.letter_date?item.letter_date.split('T')[0]:new Date().toISOString().split('T')[0],
      signedBy:item.signed_by||'Joshua Owiredu',
      signedByTitle:item.signed_by_title||'General Manager',
      refNumber:item.ref_number||'',
    } : { ...empty, date:new Date().toISOString().split('T')[0] });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try {
      const payload = {
        toName:form.toName, toTitle:form.toTitle, toCompany:form.toCompany,
        toAddress:form.toAddress, subject:form.subject, body:form.body,
        date:form.date, signedBy:form.signedBy, signedByTitle:form.signedByTitle,
        refNumber:form.refNumber,
      };
      let saved;
      if (editing) { const r=await api.put(`/letterheads/${editing.id}`,payload); saved=r.data; toast.success('Updated!'); }
      else { const r=await api.post('/letterheads',payload); saved=r.data; toast.success('Letter created!'); }
      setEditing(saved); setShowPreview(true); setShowForm(false); loadLetters();
    } catch { toast.error('Failed to save'); }
    setSubmitting(false);
  };

  const downloadPDF = async () => {
    const el = document.getElementById('letterhead-render');
    if (!el) return;
    setGenerating(true);
    try {
      const freshLogo = await toBase64('/logo.png');
      const canvas = await html2canvas(el, {
        scale:3, useCORS:true, allowTaint:true, backgroundColor:'#ffffff',
        logging:false, imageTimeout:0, width:595, height:842,
        onclone:(clonedDoc) => {
          const c = clonedDoc.getElementById('letterhead-render');
          if (c) {
            c.style.width='595px'; c.style.height='842px';
            c.style.position='relative'; c.style.transform='none';
            c.style.margin='0'; c.style.overflow='hidden';
            c.querySelectorAll('img').forEach(img => {
              if (img.getAttribute('alt')==='SQS Logo') img.src=freshLogo;
              img.style.display='block';
            });
          }
        }
      });
      const pdf = new jsPDF({ orientation:'portrait', unit:'mm', format:'a4' });
      pdf.addImage(canvas.toDataURL('image/png',1.0),'PNG',0,0,210,297,undefined,'FAST');
      pdf.save(`SQS-Letter-${editing?.ref_number||Date.now()}.pdf`);
      toast.success('Downloaded!');
    } catch(err) { console.error(err); toast.error('Failed to generate PDF'); }
    setGenerating(false);
  };

  const viewLetter = (l) => {
    setEditing(l);
    setForm({
      toName:l.to_name||'', toTitle:l.to_title||'', toCompany:l.to_company||'',
      toAddress:l.to_address||'', subject:l.subject||'', body:l.body||'',
      date:l.letter_date?l.letter_date.split('T')[0]:new Date().toISOString().split('T')[0],
      signedBy:l.signed_by||'Joshua Owiredu', signedByTitle:l.signed_by_title||'General Manager',
      refNumber:l.ref_number||'',
    });
    setShowPreview(true); setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this letter?')) return;
    try {
      await api.delete(`/letterheads/${id}`);
      toast.success('Deleted'); loadLetters();
      if (editing?.id===id) { setShowPreview(false); setEditing(null); }
    } catch { toast.error('Failed'); }
  };

  return (
    <AdminLayout title="Letterhead Generator">
      <div style={{ maxWidth:1100 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
          <p style={{ color:'var(--gray-400)', fontSize:'0.875rem' }}>{letters.length} letter{letters.length!==1?'s':''} created</p>
          <button onClick={()=>{ setShowPreview(false); openForm(); }} className="btn btn-navy btn-sm">
            <FiPlus /> New Letter
          </button>
        </div>

        {/* Form */}
        {showForm && (
          <motion.div initial={{ opacity:0, y:-16 }} animate={{ opacity:1, y:0 }}
            style={{ background:'white', borderRadius:'16px', padding:'2rem', marginBottom:'2rem', boxShadow:'var(--shadow)', border:'1px solid #E5E7EB' }}>
            <h3 style={{ fontFamily:'Fraunces,serif', color:'var(--navy)', marginBottom:'1.5rem', fontSize:'1.05rem' }}>
              {editing ? 'Edit Letter' : 'Create New Letter'}
            </h3>
            <form onSubmit={handleSubmit}>
              <div style={{ background:'var(--off-white)', borderRadius:'10px', padding:'1rem 1.25rem', marginBottom:'1.25rem', border:'1px solid var(--gray-100)' }}>
                <p style={{ fontSize:'0.78rem', fontWeight:600, color:'var(--navy)', marginBottom:'0.75rem', textTransform:'uppercase', letterSpacing:'0.08em' }}>Recipient (TO)</p>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Full Name</label><input className="form-input" value={form.toName} onChange={e=>setForm({...form,toName:e.target.value})} placeholder="e.g. Dr. Kwame Mensah" /></div>
                  <div className="form-group"><label className="form-label">Title / Position</label><input className="form-input" value={form.toTitle} onChange={e=>setForm({...form,toTitle:e.target.value})} placeholder="e.g. CEO" /></div>
                </div>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Company</label><input className="form-input" value={form.toCompany} onChange={e=>setForm({...form,toCompany:e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Address</label><input className="form-input" value={form.toAddress} onChange={e=>setForm({...form,toAddress:e.target.value})} placeholder="City, Country" /></div>
                </div>
              </div>

              <div className="grid-2">
                <div className="form-group"><label className="form-label">Date *</label><input className="form-input" type="date" required value={form.date} onChange={e=>setForm({...form,date:e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Reference Number</label><input className="form-input" value={form.refNumber} onChange={e=>setForm({...form,refNumber:e.target.value})} placeholder="e.g. SQS/2026/001" /></div>
              </div>
              <div className="form-group"><label className="form-label">Subject (RE:) *</label><input className="form-input" required value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})} placeholder="e.g. Food Safety Audit Report" /></div>
              <div className="form-group">
                <label className="form-label">Letter Body *</label>
                <textarea className="form-input" required style={{ minHeight:220, lineHeight:1.8 }} value={form.body} onChange={e=>setForm({...form,body:e.target.value})} placeholder={"Dear Sir/Madam,\n\nWrite the body of your letter here...\n\nEach new line is preserved exactly."} />
              </div>

              <div style={{ background:'var(--off-white)', borderRadius:'10px', padding:'1rem 1.25rem', marginBottom:'1.25rem', border:'1px solid var(--gray-100)' }}>
                <p style={{ fontSize:'0.78rem', fontWeight:600, color:'var(--navy)', marginBottom:'0.75rem', textTransform:'uppercase', letterSpacing:'0.08em' }}>Signatory</p>
                <div className="grid-2">
                  <div className="form-group" style={{ marginBottom:0 }}><label className="form-label">Signed By</label><input className="form-input" value={form.signedBy} onChange={e=>setForm({...form,signedBy:e.target.value})} /></div>
                  <div className="form-group" style={{ marginBottom:0 }}><label className="form-label">Title</label><input className="form-input" value={form.signedByTitle} onChange={e=>setForm({...form,signedByTitle:e.target.value})} /></div>
                </div>
              </div>

              <div style={{ display:'flex', gap:'0.75rem' }}>
                <button type="submit" className="btn btn-navy btn-sm" disabled={submitting}>{submitting?'Saving...':editing?'Update & Preview':'Create & Preview'}</button>
                <button type="button" className="btn btn-sm" style={{ background:'#F3F4F6', color:'var(--gray-600)' }} onClick={()=>{ setShowForm(false); setEditing(null); }}>Cancel</button>
              </div>
            </form>
          </motion.div>
        )}

        {/* Preview */}
        {showPreview && editing && (
          <motion.div initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }}
            style={{ background:'white', borderRadius:'16px', padding:'2rem', marginBottom:'2rem', boxShadow:'var(--shadow-lg)', border:'2px solid #F5821F' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem', flexWrap:'wrap', gap:'0.75rem' }}>
              <div>
                <h3 style={{ fontFamily:'Fraunces,serif', fontSize:'1rem', color:'var(--navy)' }}>Letter Preview</h3>
                {editing.ref_number && <p style={{ color:'var(--gray-400)', fontSize:'0.78rem', marginTop:'0.15rem' }}>Ref: <strong>{editing.ref_number}</strong></p>}
              </div>
              <div style={{ display:'flex', gap:'0.75rem', flexWrap:'wrap' }}>
                <button onClick={()=>openForm(editing)} className="btn btn-sm" style={{ background:'#DBEAFE', color:'#1E40AF', display:'flex', alignItems:'center', gap:'0.4rem' }}><FiEdit2/>Edit</button>
                <button onClick={downloadPDF} className="btn btn-sm" style={{ background:'#F5821F', color:'white', display:'flex', alignItems:'center', gap:'0.4rem' }} disabled={generating}>
                  <FiDownload/>{generating?'Generating...':'Download PDF'}
                </button>
                <button onClick={()=>setShowPreview(false)} className="btn btn-sm" style={{ background:'#F3F4F6', color:'var(--gray-600)' }}>Close</button>
              </div>
            </div>
            <div style={{ overflowX:'auto', background:'#F3F4F6', padding:'1.5rem', borderRadius:'12px', display:'flex', justifyContent:'center' }}>
              <LetterheadPreview data={form} logoSrc="/logo.png" />
            </div>
          </motion.div>
        )}

        {/* Table */}
        <div style={{ background:'white', borderRadius:'16px', overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:'1px solid #F3F4F6' }}>
          {letters.length===0 ? (
            <div style={{ padding:'4rem', textAlign:'center', color:'var(--gray-400)' }}>
              <div style={{ fontSize:'3rem', marginBottom:'1rem' }}>📄</div>
              <p>No letters yet. Click "New Letter" to get started.</p>
            </div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ background:'#F9FAFB', borderBottom:'1px solid #F3F4F6' }}>
                  {['Ref','To','Subject','Date','Actions'].map(h=>(
                    <th key={h} style={{ padding:'0.875rem 1rem', textAlign:'left', fontSize:'0.73rem', fontWeight:600, color:'var(--gray-400)', textTransform:'uppercase', letterSpacing:'0.08em' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {letters.map((l,i)=>(
                  <tr key={l.id} style={{ borderBottom:'1px solid #F9FAFB', background:i%2===0?'white':'#FAFAFA' }}>
                    <td style={{ padding:'0.875rem 1rem', fontFamily:'monospace', fontSize:'0.82rem', color:'var(--navy)', fontWeight:600 }}>{l.ref_number||'—'}</td>
                    <td style={{ padding:'0.875rem 1rem' }}>
                      <div style={{ fontWeight:600, color:'var(--navy)', fontSize:'0.875rem' }}>{l.to_name||'—'}</div>
                      {l.to_company&&<div style={{ color:'var(--gray-400)', fontSize:'0.77rem' }}>{l.to_company}</div>}
                    </td>
                    <td style={{ padding:'0.875rem 1rem', color:'var(--gray-600)', fontSize:'0.85rem' }}>{l.subject}</td>
                    <td style={{ padding:'0.875rem 1rem', color:'var(--gray-500)', fontSize:'0.8rem' }}>
                      {l.letter_date?new Date(l.letter_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}):'—'}
                    </td>
                    <td style={{ padding:'0.875rem 1rem' }}>
                      <div style={{ display:'flex', gap:'0.4rem' }}>
                        <button onClick={()=>viewLetter(l)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#DCFCE7', color:'#166534', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiEye/></button>
                        <button onClick={()=>openForm(l)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#DBEAFE', color:'#1E40AF', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiEdit2/></button>
                        <button onClick={()=>handleDelete(l.id)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#FEE2E2', color:'#991B1B', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiTrash2/></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}